module.exports = __webpack_public_path__ + "img/33_39.23643129.png";